// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from 'vue'
import App from './App'
import router from './router/index.js'
import store from './vuex/store'
// 引入全局样式
import 'styles/reset.css'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
import './assets/css/theme01.less';


//引入jquery 以及ztree
//import './assets/js/jquery-3.3.1.min.js'
////import './assets/js/global.js'
//import './assets/js/ztree/jquery.ztree.core.min.js'
//import './assets/js/ztree/jquery.ztree.exedit.min.js'
//import './assets/js/ztree/jquery.ztree.excheck.min.js'
//import './assets/css/zTreeStyle/zTreeStyle.css'

//引入element ui
//import ElementUI from 'element-ui'
//import 'element-ui/lib/theme-chalk/index.css'
//Vue.use(ElementUI);


// 引入导航css
import '@/assets/css/nav/component.css'
import '@/assets/css/nav/demo.css'
import '@/assets/css/nav/normalize.css'
import request from '@/utils/request'
import {dictApi} from './utils/DictApi'
import echarts from 'echarts'
import china from 'echarts/map/json/china.json'
import echartsGL from 'echarts-gl' // 引入echarts
import inMap from 'inmap'
import vueResource from 'vue-resource'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// 全局引入百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak
  ak: 'd0jFRyzash7kA2clCRNg4O4GKVXbHGt1'
})

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

//引入打印
import Print from 'vue-print-nb'
import htmlToPdf from '@/utils/htmlToPdf'

Vue.use(htmlToPdf)


Vue.use(Print);  //注册打印
Vue.use(VueQuillEditor)

Vue.prototype.$echarts = echarts
Vue.prototype.$echartsGL = echartsGL // 引入组件（将echarts注册为全局）
Vue.prototype.$inMap = inMap
Vue.prototype.req = request
//全局判断是否有权限的函数
Vue.prototype.hasMenuEnName = function (menuEnName) {
  return this.$store.getters.hasMenuEnName(menuEnName)
}
//全局判断是否有权限的函数
Vue.prototype.isShow = function (menuId) {
  return this.$store.getters.isShow(menuId)
}
Vue.prototype.dictApi = dictApi

Vue.use(router);
Vue.use(iView)
Vue.use(vueResource)
//Vue.use(Viewer) 默认配置写法
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
/* eslint-disable no-new */
let vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  
})



// WEBPACK FOOTER //
// ./src/main.js